/**
 * 維修報告 list query → API params。
 * - sort id：camel → snake（BE 白名單為 snake）
 * - status：陣列改單一 `status=DRAFT,COMPLETED` 逗號 OR
 */
import {
  DEFAULT_LIST_PAGE,
  DEFAULT_LIST_PAGE_SIZE,
} from '#/utils/listUrl/listPaginationDefaults';

function toSnakeKey(key) {
  return String(key ?? '').replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
}

/**
 * @param {object} listQuery
 * @returns {URLSearchParams}
 */
export function listQueryToRepairReportApiParams(listQuery) {
  const params = new URLSearchParams();
  params.set('page', String(listQuery?.page || DEFAULT_LIST_PAGE));
  params.set('page_size', String(listQuery?.pageSize || DEFAULT_LIST_PAGE_SIZE));

  if (listQuery?.keyword) {
    params.set('keyword', listQuery.keyword);
  }

  (listQuery?.sort || []).forEach(({ id, desc }) => {
    if (!id) {
      return;
    }
    params.append('sort', `${toSnakeKey(id)},${desc ? 'desc' : 'asc'}`);
  });

  Object.entries(listQuery?.filters || {}).forEach(([key, value]) => {
    const snakeKey = toSnakeKey(key);

    if (key === 'status') {
      const statuses = (Array.isArray(value) ? value : [value])
        .map((item) => String(item ?? '').trim())
        .filter(Boolean);
      if (statuses.length > 0) {
        params.set('status', statuses.join(','));
      }
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item) {
          params.append(snakeKey, item);
        }
      });
      return;
    }

    if (value) {
      params.set(snakeKey, value);
    }
  });

  return params;
}
